<template>
  <div class="container">
    <el-row>
      <el-col :span="2">
        <cma-catalog :site-type="this.site_type" :project-id="this.project_id" :site-id="this.site_id"
                     :rr-type="this.rr_type" :route-name="'site_'+this.site_type+'_list'"></cma-catalog>
      </el-col>

      <el-col :span="22">
        <el-select v-model="currentPage" @change="handleChange" placeholder="请选择页数" size="mini">
          <el-option
              v-for="item in pages"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <table>
          <tr>
            <td colspan="9">3.1.1检测结果/数据</td>
          </tr>
          <tr>
            <td>环境温度（℃）</td>
            <td colspan="2">
              <p>{{ form.hjwd }}</p>
            </td>
            <td>环境湿度（%RH）</td>
            <td colspan="2">
              <p>{{ form.hjsd }}</p>
            </td>
            <td>风速（m/s）</td>
            <td colspan="2">
              <p>{{ form.fs }}</p>
            </td>
          </tr>
          <tr>
            <td>辐射系数</td>
            <td colspan="2">
              <p>{{ form.fsxs }}</p>
            </td>
            <td>额定电压（V）</td>
            <td colspan="2">
              <p>{{ form.eddy }}</p>
            </td>
            <td>额定电流（A）</td>
            <td colspan="2">
              <p>{{ form.eddl }}</p>
            </td>
          </tr>
          <tr>
            <td>被检测设备位置</td>
            <td colspan="2">
              <p>{{ form.bjcsbwz }}</p>
            </td>
            <td>被检测设备名称</td>
            <td colspan="2">
              <p>{{ form.bjcsbmc }}</p>
            </td>
            <td>型号规格</td>
            <td colspan="2">
              <p>{{ form.xhgg }}</p>
            </td>
          </tr>
          <tr>
            <td>电压值（V）</td>
            <td>A-B</td>
            <td>
              <p>{{ form.dy_ab }}</p>
            </td>
            <td>A-C</td>
            <td>
              <p>{{ form.dy_ac }}</p>
            </td>
            <td>B-C</td>
            <td>
              <p>{{ form.dy_bc }}</p>
            </td>
            <td>L-N</td>
            <td>
              <p>{{ form.dy_ln }}</p>
            </td>
          </tr>
          <tr>
            <td colspan="3">数据/位置</td>
            <td colspan="2">A相</td>
            <td colspan="2">B相</td>
            <td>C相</td>
            <td>零线</td>
          </tr>
          <tr>
            <td rowspan="2">实测温度</td>
            <td colspan="2">进线</td>
            <td colspan="2">
              <p>{{ form.a_in }}</p>
            </td>
            <td colspan="2">
              <p>{{ form.b_in }}</p>
            </td>
            <td>
              <p>{{ form.c_in }}</p>
            </td>
            <td>
              <p>{{ form.zero_in }}</p>
            </td>
          </tr>
          <tr>
            <td colspan="2">出线</td>
            <td colspan="2">
              <p>{{ form.a_out }}</p>
            </td>
            <td colspan="2">
              <p>{{ form.b_out }}</p>
            </td>
            <td>
              <p>{{ form.c_out }}</p>
            </td>
            <td>
              <p>{{ form.zero_out }}</p>
            </td>
          </tr>
          <tr>
            <td colspan="3">负荷电流</td>
            <td colspan="2">
              <p>{{ form.a_dl }}</p>
            </td>
            <td colspan="2">
              <p>{{ form.b_dl }}</p>
            </td>
            <td>
              <p>{{ form.c_dl }}</p>
            </td>
            <td>
              <p>{{ form.zero_dl }}</p>
            </td>
          </tr>
          <tr>
            <td>温升（K）</td>
            <td colspan="2">
              <p>{{ form.ws }}</p>
            </td>
            <td>相对温差（%）</td>
            <td colspan="2">
              <p>{{ form.xdwc }}</p>
            </td>
            <td>图像编号</td>
            <td colspan="2">
              <p>{{ form.txbh }}</p>
            </td>
          </tr>
          <tr>
            <td>检测结果</td>
            <td colspan="8">
              <p>{{ form.jcjg }}</p>
            </td>
          </tr>
          <tr>
            <td colspan="9">
              <el-image :src="form.image2_src"></el-image>
            </td>
          </tr>
          <tr>
            <td>备注</td>
            <td colspan="8">相对温差：δ=(T1-T2)/(T1-T0) ×100%，式中：T1—发热点的温升和温度；T2—正常相对应点的温升和温度；T0—被测设备区域的环境温度—气温。
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      project_id: '',
      site_id: '',
      site_type: '',
      zg_type: 'cma_311',
      rr_type: 'report',
      pages: [],
      currentPage: '',
      maxPage: 0,
      form: {
        hjwd: '',
        hjsd: '',
        fs: '',
        fsxs: '',
        eddy: '',
        eddl: '',
        bjcsbwz: '',
        bjcsbmc: '',
        xhgg: '',
        dy_ab: '',
        dy_ac: '',
        dy_bc: '',
        dy_ln: '',
        a_in: '',
        a_out: '',
        a_dl: '',
        b_in: '',
        b_out: '',
        b_dl: '',
        c_in: '',
        c_out: '',
        c_dl: '',
        zero_in: '',
        zero_out: '',
        zero_dl: '',
        ws: '',
        xdwc: '',
        txbh: '',
        jcy: '',
        jly: '',
        jcsj: '',
        image2_src: ''
      },
    }
  },
  methods: {
    //获取所有页码
    async setPages() {
      try {
        this.pages = [];
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
          zg_type: this.zg_type
        }
        let res = await this.$Api.post('get_max_page', params)
        if (res) {
          this.maxPage = res.max_page
          if (this.maxPage > 0) {
            for (let i = 1; i <= this.maxPage; i++) {
              this.pages.push({value: i, label: i})
            }
          } else {
            this.pages.push({value: 1, label: 1})
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //获取原始记录
    async getData(page) {
      try {
        let params = {
          current_page: page,
          site_id: this.site_id,
          project_id: this.project_id
        }
        let res = await this.$Api.post('get_record_cma_311', params)
        if (res) {
          this.currentPage = res.current_page
          this.form = res
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //切页
    handleChange(page) {
      this.getData(page)
    },
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.setPages();
    this.getData(1)
  }
}
</script>
<style scoped>
table {
  width: 100%;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  vertical-align: middle !important;
}
</style>
